var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconArrowDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 8,
  viewBox: "0 0 14 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.544 0L6.58824 4.93675L11.632 0L13.1765 1.51889L6.58824 8L0 1.51889L1.544 0Z",
  fill: "black"
})));
export default SvgIconArrowDown;